<template>
  <el-row
    class="passport-pictures"
    v-loading.fullscreen.lock="fullScreenLoading"
  >
    <el-col
      :sm="{span:14, offset: 5}"
      :md="{span:12, offset: 6}"
      :lg="{span:12, offset: 6}"
    >
      <el-header
        height="140px"
        class="app-header pt-50 pb-30"
      >
        <Menu />
        <h3 class="app-header-title mt-0">
          {{ $t('profile.passport') }}
        </h3>
      </el-header>
      <el-main>
        <el-form
          label-position="top"
        >
          <el-form-item :label="$t('passport-upload.front-side')">
            <el-upload
              class="passport-pictures__uploader"
              drag
              action="#"
              accept="image/png, image/jpg, image/jpeg"
              :limit="1"
              :on-exceed="handleExceed"
              :http-request="uploadPassportPictures"
              :before-upload="beforePassportUpload"
              :file-list="passportPictures"
            >
              <i class="el-icon-upload" />
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('passport-upload.back-side')">
            <el-upload
              class="passport-pictures__uploader"
              drag
              action="#"
              accept="image/png, image/jpg, image/jpeg"
              :on-exceed="handleExceed"
              :http-request="uploadPassportPictures"
              :before-upload="beforePassportUpload"
              :file-list="passportPictures"
            >
              <i class="el-icon-upload" />
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('passport-upload.address-confirm')">
            <el-upload
              class="passport-pictures__uploader"
              drag
              action="#"
              accept="image/png, image/jpg, image/jpeg"
              :on-exceed="handleExceed"
              :http-request="uploadPassportPictures"
              :before-upload="beforePassportUpload"
              :file-list="passportPictures"
            >
              <i class="el-icon-upload" />
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-main>
    </el-col>
  </el-row>
</template>

<script>
import Menu from '../Menu/Menu';

export default {
  name: 'UploadPassport',
  components: {
    Menu
  },
  data: () => ({
    fullScreenLoading: false,
    passportPictures: []
  }),
  methods: {
    beforePassportUpload (file) {
      const isLt1M = file.size / 1024 / 1024 < 50;

      if (!isLt1M) {
        this.$message.error(this.$t('form.validation.avatar-size', { size: '50MB' }));
      }
      return isLt1M;
    },
    handleExceed () {
      this.$message.warning(`The limit is 1`);
    },
    uploadPassportPictures (request) {
      this.fullScreenLoading = true;
      const fd = new FormData();

      fd.append('image', request.file);
      fd.append('emailing', 'true');

      this.$adminApi.post('/api/v1/employees/kyc-upload', fd).then(() => {
        this.fullScreenLoading = false;
        this.$message.success(this.$t('form.file-uploaded'));
      }).catch(() => {
        this.fullScreenLoading = false;
        this.$message.success(this.$t('form.file-not-uploaded'));
      });
    }
  }
};
</script>

<style lang="scss">
.passport-pictures {
  margin-bottom: 50px;
}
</style>
